import { useState } from "react";
import { useSelector } from "react-redux";

import Modal, { ModalBody, ModalFooter } from "../../components/Modal/Modal";
import { validateEmail } from "../../utils";
import { resendOrders } from "../../services/orders";
import { RootState } from "../../store";
import PrimaryButton from "../../components/Buttons/PrimaryButton";
import Input from "../../components/Inputs/Input";
import classes from "./ResendOrderLink.module.css";

type Props = {
  onClose: () => void;
};

const ResendOrderLink: React.FC<Props> = ({ onClose }) => {
  const { id } = useSelector((state: RootState) => state.pod.pod);
  const [email, setEmail] = useState("");

  const resendOrderHandler = async () => {
    try {
      await resendOrders(id, email);
      onClose();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal
    className={classes.modalContainer}
      title={<div className={classes.title}>Resend order links</div>}
      onClose={onClose}>
      <>
        <ModalBody>
          <div className={classes.description}>
            If you lost the link to your order(s), please enter the email
            address you used for your order. If you have registered for any medical
            service, we will send you an email with links to your upcoming orders.
          </div>
          <Input
            className={classes.emailInput}
            name='Email'
            placeholder='E-mail'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <PrimaryButton
            className={classes.action}
            name={"Send links"}
            onClick={resendOrderHandler}
            disabled={!validateEmail(email)}
          />
        </ModalFooter>
      </>
    </Modal>
  );
};

export default ResendOrderLink;
